"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellRegistryEntries = exports.rendererRegistryEntries = void 0;
const core_1 = require("@jsonforms/core");
const react_1 = require("@jsonforms/react");
const BooleanControl_1 = require("./controls/BooleanControl");
const AlertLayout_1 = require("./layouts/AlertLayout");
const TextControl_1 = require("./controls/TextControl");
const UnknownControl_1 = require("./controls/UnknownControl");
const HorizontalLayout_1 = require("./layouts/HorizontalLayout");
const VerticalLayout_1 = require("./layouts/VerticalLayout");
const ObjectControl_1 = require("./controls/ObjectControl");
const GroupLayout_1 = require("./layouts/GroupLayout");
const NumericControl_1 = require("./controls/NumericControl");
const NumericSliderControl_1 = require("./controls/NumericSliderControl");
const ObjectArrayControl_1 = require("./controls/ObjectArrayControl");
const PrimitiveArrayControl_1 = require("./controls/PrimitiveArrayControl");
const OneOfControl_1 = require("./controls/combinators/OneOfControl");
const AnyOfControl_1 = require("./controls/combinators/AnyOfControl");
const EnumControl_1 = require("./controls/EnumControl");
// Ordered from lowest rank to highest rank. Higher rank renderers will be preferred over lower rank renderers.
exports.rendererRegistryEntries = [
    {
        tester: (0, core_1.rankWith)(1, () => true),
        renderer: UnknownControl_1.UnknownRenderer,
    },
    {
        tester: (0, core_1.rankWith)(2, (0, core_1.uiTypeIs)("Group")),
        renderer: GroupLayout_1.GroupLayoutRenderer,
    },
    {
        tester: (0, core_1.rankWith)(2, (0, core_1.uiTypeIs)("HorizontalLayout")),
        renderer: HorizontalLayout_1.HorizontalLayoutRenderer,
    },
    {
        tester: (0, core_1.rankWith)(2, (0, core_1.uiTypeIs)("VerticalLayout")),
        renderer: VerticalLayout_1.VerticalLayoutRenderer,
    },
    {
        tester: (0, core_1.rankWith)(2, core_1.isBooleanControl),
        renderer: BooleanControl_1.BooleanRenderer,
    },
    {
        tester: (0, core_1.rankWith)(2, core_1.isStringControl),
        renderer: TextControl_1.TextRenderer,
    },
    {
        tester: (0, core_1.rankWith)(2, (0, core_1.uiTypeIs)("Label")),
        renderer: AlertLayout_1.AlertLayoutRenderer,
    },
    {
        tester: (0, core_1.rankWith)(2, (0, core_1.or)(core_1.isNumberControl, core_1.isIntegerControl)),
        renderer: NumericControl_1.NumericRenderer,
    },
    {
        tester: (0, core_1.rankWith)(3, (0, core_1.and)((0, core_1.or)(core_1.isNumberControl, core_1.isIntegerControl), (0, core_1.schemaMatches)((schema) => {
            return schema.minimum !== undefined && schema.maximum !== undefined;
        }))),
        renderer: NumericSliderControl_1.NumericSliderRenderer,
    },
    {
        tester: (0, core_1.rankWith)(4, core_1.isEnumControl),
        renderer: EnumControl_1.EnumRenderer,
    },
    {
        tester: (0, core_1.rankWith)(5, core_1.isOneOfControl),
        renderer: OneOfControl_1.OneOfRenderer,
    },
    {
        tester: (0, core_1.rankWith)(5, core_1.isAnyOfControl),
        renderer: AnyOfControl_1.AnyOfRenderer,
    },
    {
        tester: (0, core_1.rankWith)(5, (0, core_1.or)(core_1.isObjectArrayControl, core_1.isObjectArray, core_1.isObjectArrayWithNesting)),
        renderer: ObjectArrayControl_1.ObjectArrayRenderer,
    },
    {
        tester: (0, core_1.rankWith)(10, (0, core_1.and)(core_1.isObjectControl, (0, core_1.not)(core_1.isLayout))),
        renderer: ObjectControl_1.ObjectRenderer,
    },
    {
        tester: (0, core_1.rankWith)(30, core_1.isPrimitiveArrayControl),
        renderer: PrimitiveArrayControl_1.PrimitiveArrayRenderer,
    },
];
exports.cellRegistryEntries = [
    {
        tester: (0, core_1.rankWith)(1, () => true),
        cell: (0, react_1.withJsonFormsCellProps)(UnknownControl_1.UnknownControl),
    },
];
